export const accessoryApi = {
  // 初始化信息
  getInit: {
      method: 'post',
      api: 'backend/setting/getInit',
  },
  setInit: {
    method: 'post',
    api: 'backend/setting/setInit',
  },
  getInfo: {
    method: 'post',
    api: 'backend/setting/getInfo',
  },
  uploadImg: {
    method: 'post',
    api: 'backend/setting/uploadImg',
  },
  uploadVideo: {
    method: 'post',
    api: 'backend/setting/uploadVideo',
  },
  getDataDoard: {
    method: 'post',
    api: 'backend/setting/getDataDoard',
  },
  get_all_warehouse_products_list: {
    method: 'post',
    api: 'backend/Index/get_all_warehouse_products_list',
  },
  update_shopline_products: {
    method: 'post',
    api: 'backend/Index/update_shopline_products',
  },
  get_warehouse_location_list: {
    method: 'post',
    api: 'backend/Index/get_warehouse_location_list',
  },
  save_warehouse_location_list: {
    method: 'post',
    api: 'backend/Index/save_warehouse_location_list',
  },
  update_shopline_products_available: {
    method: 'post',
    api: 'backend/Index/update_shopline_products_available'
  },
  get_logs: {
    method: 'post',
    api: 'backend/Index/get_logs'
  },
}
